@if (enabled) {
  <button
    class="transparent-btn"
    [disabled]="submitted"
    (click)="openModal()"
    ngbTooltip="Envoyer"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>
  <app-action-modal
    #actionModal
    [disabled]="submitted"
    [submitDisabled]="submitDisabled"
    [showHeader]="true"
    submitButtonClass="lty-btn-primary"
    size="lg"
    headerIconState="success"
    customModalClass="send-centralisation-modal"
    (submitted)="sendCentralisation()"
    (closed)="onClosed()"
  >
    <div class="proposals-send-icon d-flex" headerIcon>
      <app-send-icon height="16px" width="16px" color="var(--success-500)" />
    </div>
    <ng-container mainTitle i18n>Envoyer à l'assureur</ng-container>
    <ng-container subtitle>
      <form class="lty-form mt-12" [formGroup]="form">
        <div class="form-group mb-16">
          <label for="centralisation-send-mode" i18n>Envoi</label>
          <div class="position-relative">
            <select
              class="form-control"
              id="centralisation-send-mode"
              formControlName="sendMode"
            >
              <option [value]="SendMode.PLATFORM" i18n>Par mail</option>
              <option [value]="SendMode.OFF_PLATFORM" i18n>
                Manuel (hors plateforme)
              </option>
            </select>
            <i class="bi bi-chevron-down edge-element"></i>
          </div>
        </div>

        @if (isPlatformSend) {
          <div class="form-group mb-16">
            <label i18n>Mandat de gestion <app-required-field-mark /></label>
            <app-signed-contract-document-combobox
              [control]="form.controls.managementAgreementDocument"
              [familyMemberId]="familyMemberId"
              [userId]="userId"
              [contractType]="ContractType.MANAGEMENT_AGREEMENT"
            />
          </div>

          <div class="form-group mb-16">
            <label i18n>Article 45</label>
            <app-signed-contract-document-combobox
              [control]="form.controls.lsa45Document"
              [familyMemberId]="familyMemberId"
              [userId]="userId"
              [contractType]="ContractType.ARTICLE_45"
              [required]="false"
            />
          </div>

          <div class="form-group mb-16">
            <label i18n>Carte d'identité</label>
            <app-document-summary-combobox
              [control]="form.controls.identityCard"
              [userId]="userId"
              [memberId]="familyMemberId"
              [type]="DocumentType.IDENTITY_CARD"
              noneLabel="Aucune"
              i18n-noneLabel
            />
          </div>
          <div class="form-group mb-16">
            <label i18n>Certificat de signature</label>
            <app-document-summary-combobox
              [control]="form.controls.signatureCertificate"
              [userId]="userId"
              [memberId]="familyMemberId"
              [type]="DocumentType.SIGNATURE_CERTIFICATE"
            />
          </div>

          <!-- Same lifecycle gate as the editors: the picker searches as soon as it exists. -->
          @if (modalOpen) {
            <app-document-picker
              [control]="form.controls.attachments"
              [userId]="userId ?? ''"
              [familyMemberId]="familyMemberId ?? ''"
              label="Autre(s) document(s)"
              i18n-label
              [allowUpload]="true"
            />
          }

          <!-- One mail per selected company and branch; the strip only earns its place past one. -->
          @if (mails.length > 1) {
            <app-filter-tabs
              class="mb-16 d-block"
              [tabs]="mailTabs"
              [activeTab]="'' + activeMailIndex"
              (tabChange)="setActiveMail($event)"
            />
          }

          <div class="form-group mb-16">
            <label for="centralisation-recipient" i18n>Destinataire</label>
            <input
              class="form-control"
              type="text"
              id="centralisation-recipient"
              [value]="activeRecipientEmail"
              [placeholder]="renderLoading ? loadingText : ''"
              readonly
            />
          </div>

          <!-- `modalOpen` is a TinyMCE lifecycle gate; see `ComposeModalBase`. Keyed on the
                         active tab so switching tabs hands the editor the right mail's control. -->
          @if (modalOpen && activeBodyControl) {
            <div class="form-group mb-16">
              <label i18n>Corps du mail</label>
              <editor
                [formControl]="activeBodyControl"
                [plugins]="editorPlugins"
                [toolbar]="editorToolbar"
              />
            </div>
          }
        }
      </form>
    </ng-container>
    <ng-container submitButtonLabel i18n>Confirmer</ng-container>
  </app-action-modal>
}
